var map = {
	"./humidity.png": 711,
	"./pressure.png": 297,
	"./sunrise-small.png": 817,
	"./sunrise.png": 971,
	"./sunset-small.png": 392,
	"./sunset.png": 866,
	"./uvi.png": 500,
	"./visibility.png": 192,
	"./wind.png": 554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;